import en from 'translations/en/popularProductsTable.json';
import pl from 'translations/pl/popularProductsTable.json';
import sl from 'translations/sl/popularProductsTable.json';
import { ITranslations } from 'types/common';
import { PopularProductsTableTransFields } from './types';

export const popularProductsTableTranslations: ITranslations<PopularProductsTableTransFields> = {
  name: 'popularProductsTable',
  en,
  pl,
  sl,
};
